export class APIConstants {
  public static readonly COURSE_TAGS_ENDPOINT = '/public/course/course-tags';
  public static readonly COURSES_ENDPOINT = '/public/course/list';
  public static readonly PRIVATE_COURSES_ENDPOINT = '/course/list';
  public static readonly DISCOVERY_OPTIONS_ENDPOINT = '/public/enquiry/discovery-options';
  public static readonly SUBMIT_ENQUIRY_ENDPOINT = '/public/enquiry';
  public static readonly LOGIN_ENDPOINT = '/auth/login';
  public static readonly SET_PASSWORD_ENDPOINT = '/auth/set-password';
  public static readonly LOGOUT_ENDPOINT = '/auth/logout';
  public static readonly WHOAMI_ENDPOINT = '/users/whoami';
  public static readonly GET_ALL_ADMINS_ENDPOINT = '/users/admins';
  public static readonly CREATE_ADMIN_ENDPOINT = '/users/admin';
  public static readonly REQUEST_PASSWORD_RESET_ENDPOINT = (userId: string) =>
    `/users/${userId}/reset-password`;
  public static readonly REQUEST_PASSWORD_FORGOT_ENDPOINT = `/auth/forgot-password`;
  public static readonly GET_ALL_LEADS_ENDPOINT = '/enquiry/list';
  public static readonly GET_ALL_ENQUIRY_STATUSES_ENDPOINT = '/enquiry/statuses';
  public static readonly GET_ALL_ENQUIRY_UPDATES_ENDPOINT = (enquiryId: string) =>
    `/enquiry/${enquiryId}/updates`;
  public static readonly UPDATE_ENQUIRY_ENDPOINT = '/enquiry/update-status';
  public static readonly CHANGE_ENQUIRY_OWNER_ENDPOINT = (enquiryId: string, newOwnerId: string) =>
    `/enquiry/${enquiryId}/change-owner/${newOwnerId}`;
  public static readonly GET_ALL_COURSES_ENDPOINT = '/course/list';
  public static readonly GET_ALL_TECHNOLOGIES_ENDPOINT = '/course/technologies';
  public static readonly ADD_TECHNOLOGY_BULK_ENDPOINT = '/course/technonologies/bulk';
  public static readonly ADD_TECHNOLOGY_ENDPOINT = '/course/technology';
  public static readonly CREATE_COURSE_ENDPOINT = '/course';
  public static readonly GET_COURSE_PRICES_ENDPOINT = (courseId: string) =>
    `/course/${courseId}/nested-prices`;
  public static readonly OFFERS_ENDPOINT = '/offer';
  public static readonly OFFER_TYPES_ENDPOINT = '/offer/types';
  public static readonly UPDATE_OFFER_ENDPOINT = (offerId: string) => `/offer/${offerId}`;
  public static readonly DEACTIVATE_OFFER_ENDPOINT = (offerId: string) =>
    `/offer/${offerId}/deactivate`;
  public static readonly GET_OFFERS_FOR_ENQUIRY_ENDPOINT = (enquiryId: string) =>
    `/offer/enquiry/${enquiryId}`;
  public static readonly CREATE_QUOTATION_ENDPOINT = (enquiryId: string) =>
    `/enquiry/${enquiryId}/create-quotation`;
  public static readonly GET_ALL_QUOTATION = (enquiryId: string) =>
    `/enquiry/${enquiryId}/quotations`;
  public static readonly UPDATE_USER_ENDPOINT = (userId: string) => `/users/${userId}`;
  public static readonly REQUEST_DEMO_FOR_ENQUIRY_ENDPOINT = `/enquiry/demo-request`;
  public static readonly GET_DEMO_REQUESTS_ENDPOINT = `/enquiry/demo-requests`;
  public static readonly ASSIGN_DEMO_REQUEST_ENDPOINT = `/enquiry/assign-demo-request`;
  public static readonly REQUEST_BROCHURE_ENDPOINT = `/public/course/send-brochure`;
  public static readonly GET_TESTIMONIALS_ENDPOINT = `/public/user/testimonials/best`;
  public static readonly STORE_COURSE_BROCHURE_ENDPOINT = `/course/brochure`;
  public static readonly PUT_ASSIGN_NEW_COURSE_TO_LEAD_ENDPOINT = (
    enquiryId: string,
    courseId: string,
  ) => `/enquiry/${enquiryId}/course/${courseId}`;
  public static readonly PUT_MARK_DEMO_REQUEST_AS_COMPLETED_ENDPOINT = (demoId: string) =>
    `/enquiry/demo/${demoId}/completed`;
  public static readonly ADD_UPDATE_NEW_COURSE_PLAN_ENDPOINT = `/course-plan`;
  public static readonly GET_LATEST_COURSE_PLAN_ENDPOINT = (courseId: string) =>
    `/course-plan/course/${courseId}/latest`;
  public static readonly GET_BATCH_COURSE_PLAN_ENDPOINT = (batchId: string) =>
    `/course-plan/batch/${batchId}`;
  public static readonly PATCH_DISABLE_COURSE_PLAN_ENDPOINT = (planId: string) =>
    `/course-plan/${planId}/disable`;
  public static readonly PATCH_ENABLE_COURSE_PLAN_ENDPOINT = (planId: string) =>
    `/course-plan/${planId}/enable`;

  public static readonly GET_ALL_ACTIVE_BATCHES_ENDPOINT = (courseId: string) =>
    `/batch/course/${courseId}/active`;
  public static readonly CREATE_NEW_TRAINER = `/users/trainer`;
  public static readonly GET_ALL_TRAINERS = `/users/trainers`;
  public static readonly GET_ALL_STUDENTS = `/users/students`;
  public static readonly UPDATE_STUDENT_DETAILS = (studentId: string) =>
    `/users/student/${studentId}/details`;
  public static readonly UPDATE_STUDENT_PROFILE_IMAGE = (studentId: string) =>
    `/users/student/${studentId}/profile-image`;

  public static readonly GET_STATIC_VALUES = `/public/static/all`;
  public static readonly TERMS_AND_CONDITIONS_ENDPOINT = `/terms-and-conditions`;
  public static readonly BULK_TERMS_AND_CONDITIONS_ENDPOINT = `/terms-and-conditions/bulk`;
  public static readonly UPDATE_TERMS_AND_CONDITIONS_ENDPOINT = (termsId: string) =>
    `/terms-and-conditions/${termsId}`;
  public static readonly GET_TERMS_AND_CONDITIONS_USER = (userId: string) =>
    `/terms-and-conditions/user/${userId}`;

  public static readonly ACCEPT_TERMS_AND_CONDITIONS_ENDPOINT = (userId: string, termsId: string) =>
    `/terms-and-conditions/user/${userId}/accept/${termsId}`;

  public static readonly GET_ALL_BATCHES_ENDPOINT = `/batch`;
  public static readonly GET_LATEST_BATCH_SESSION_ENDPOINT = (batchId: number) =>
    `/batch/${batchId}/session`;
  public static readonly CREATE_NEW_BATCH_ENDPOINT = `/batch`;
  public static readonly UPDATE_BATCH_ENDPOINT = (batchId: number) => `/batch/${batchId}`;
  public static readonly ASSIGN_TRAINER_TO_BATCH_ENDPOINT = (batchId: number, trainerId: string) =>
    `/batch/${batchId}/trainer/${trainerId}`;
  public static readonly ASSIGN_MANAGER_TO_BATCH_ENDPOINT = (batchId: number, managerId: string) =>
    `/batch/${batchId}/manager/${managerId}`;
  public static readonly START_BATCH_ENDPOINT = (batchId: number) => `/batch/${batchId}/start`;

  public static readonly GET_PAYMENT_STATUS = (orderId: string) => `/payment/${orderId}/status`;
  public static readonly CREATE_PAYMENT_SESSION = (orderId: string) =>
    `/payment/${orderId}/checkout`;
  public static readonly GET_ORDER_DETAILS = (orderId: string) => `/payment/${orderId}`;
  public static readonly GET_INVOICE_PDF = (invoiceId: string) => `/payment/invoice/${invoiceId}`;
  public static readonly GET_ENROLLMENT_PAYMENTS = (enrollmentId: string) =>
    `/enrollments/${enrollmentId}/payments`;
  public static readonly GET_ENROLLMENT_SESSION_HISTORY = (enrollmentId: string) =>
    `/enrollments/${enrollmentId}/session-history`;

  public static readonly COURSE_PAGE_ENDPOINT = '/public/course-page';

  public static readonly GET_COURSE_PAGE_ENDPOINT = (courseCode: string) =>
    `${APIConstants.COURSE_PAGE_ENDPOINT}/course/${courseCode}`;

  public static readonly GET_COURSE_PAGE_BY_ID_ENDPOINT = (id: string) =>
    `${APIConstants.COURSE_PAGE_ENDPOINT}/${id}`;

  public static readonly DELETE_COURSE_PAGE_ENDPOINT = (courseCode: string) =>
    `${APIConstants.COURSE_PAGE_ENDPOINT}/${courseCode}`;

  public static readonly COURSE_PAGE_EXISTS_ENDPOINT = (courseCode: string) =>
    `${APIConstants.COURSE_PAGE_ENDPOINT}/exists/${courseCode}`;
  public static readonly GET_APPLICABLE_BATCHES_FOR_ENROLLMENT = (enrollmentId: string) =>
    `/enrollments/${enrollmentId}/applicable-batches`;
  public static readonly GET_ALL_ENROLLMENTS = (studentId: string) =>
    `/enrollments/student/${studentId}`;
  public static readonly LOAD_ALL_ENROLLMENTS = `/enrollments`;
  public static readonly ASSIGN_BATCH_TO_ENROLLMENTS = (enrollmentId: string, batchId: number) =>
    `/enrollments/${enrollmentId}/batch/${batchId}`;

  public static readonly UPDATE_TRAINER_PROFILE_IMAGE = (trainerId: string) =>
    `/trainer/${trainerId}/profile-image`;

  public static readonly UPDATE_OR_GET_TRAINER_DETAILS = (trainerId: string) =>
    `/trainer/${trainerId}/details`;

  public static readonly UPDATE_OR_GET_TRAINER_CALENDAR = (trainerId: string) =>
    `/trainer/${trainerId}/calendar`;

  public static readonly GET_ALL_ASSIGNED_BATCHES_ENDPOINT = (trainerId: string) =>
    `/trainer/${trainerId}/assigned-batches`;

  public static readonly START_BATCH_SESSION_ENDPOINT = (sessionId: number) =>
    `/batch/session/${sessionId}/start`;

  public static readonly JOIN_BATCH_SESSION_ENDPOINT = (sessionId: number) =>
    `/batch/session/${sessionId}/join`;

  public static readonly COMPLETE_BATCH_SESSION_ENDPOINT = (sessionId: number) =>
    `/batch/session/${sessionId}/complete`;

  public static readonly IS_GOOGLE_ACCOUNT_CONNECTED = (userId: string) => 
    `/users/${userId}/google-account-connected`;

  public static readonly CONNECT_GOOGLE_ACCOUNT = "/users/connect-google-account";
}
